module.exports = __webpack_public_path__ + "img/usa-eye-and-ear-diseases-male.0bab8f9f.png";